import { ApiError, tryRefreshSession } from './http';
import { getAccessToken } from './tokens';

const MAPS_API_BASE = import.meta.env.VITE_MAPS_API_BASE_URL ?? 'https://x-gis.xenus.dev/api/maps';

/** Builds a src for a media.files image that works in a plain <img> tag —
 * the token travels as a query param (not a header) since <img> can't attach
 * one. Access tokens are short-lived (15 min), so this stays effectively a
 * transient link, not a permanent public URL. */
export function mediaUrl(fileId: string): string {
  const token = getAccessToken() ?? '';
  return `${MAPS_API_BASE}/media/${fileId}?token=${encodeURIComponent(token)}`;
}

export const mediaApi = {
  upload: async (file: File, _retried = false): Promise<{ id: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    const token = getAccessToken();
    const response = await fetch(`${MAPS_API_BASE}/media`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: formData,
    });

    if (response.status === 401 && !_retried && (await tryRefreshSession())) {
      return mediaApi.upload(file, true);
    }

    if (!response.ok) {
      let message = 'Не удалось загрузить файл';
      try {
        const body = await response.json();
        if (typeof body.detail === 'string') message = body.detail;
      } catch {
        // тело ответа не JSON — оставляем сообщение по умолчанию
      }
      throw new ApiError(response.status, message);
    }
    return response.json();
  },
};
